import { ListRendererFn } from "./ListRenderer";
import React from "react";
import FlatView from "../componentView/FlatView";
import clsx from "clsx";
import styles from "../styles.module.scss";

const MarketingRenderer: ListRendererFn = ({
  list,
  leaveFor,
  scrollable,
  onFocus,
  config,
}) => {
  if (config?.features?.marketing === false) return null;
  return (
    <FlatView
      list={list}
      key={list.uuid}
      leaveFor={leaveFor}
      onFocus={onFocus}
      scrollable={scrollable}
      className={clsx(
        styles.flat,
        scrollable && styles.scrollable,
        list.moreLink && styles.moreLink,
      )}
    />
  );
};
export { MarketingRenderer };
